import { PageHeader } from '@organisms';
import { Spin } from 'antd';
import { useNavigate } from 'react-router';

import { LayoutConfirmationFooter } from '../../../molecules/LayoutConfirmationFooter/LayoutConfirmationFooter.molecule';
import { PhysicCouponForm } from '../components/CouponForm/PhysicCouponForm.component';
import { useProductPhysicCoupon } from '../hooks/useProductPhysicCoupon';

export function CreateCouponPhysicPage() {
  const couponHookData = useProductPhysicCoupon();
  const navigate = useNavigate();

  return (
    <Spin spinning={couponHookData.isLoading}>
      <LayoutConfirmationFooter
        onCancel={couponHookData.handleCancel}
        onSave={couponHookData.dispatchSubmit}
        cancelLabelButton='Descartar'
        ableToSave
      >
        <PageHeader
          backToPath={() => {
            navigate(-1);
          }}
          title={'Formulário para a criação do Cupom'}
          subTitle={'Desconto de um valor específico. Exemplo: R$10,00 OFF.'}
        />

        <PhysicCouponForm couponHookData={couponHookData} />
      </LayoutConfirmationFooter>
    </Spin>
  );
}
